var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhiteIconFood(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 90,
    viewBox: "0 0 107 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_109_413)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 85,
    height: 68,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1224 31.25C63.5561 31.25 63.9748 31.3774 64.2989 31.608C64.623 31.8386 64.8301 32.1563 64.8808 32.5009L64.8932 32.6667V55.3333C64.8927 55.6944 64.7199 56.0417 64.4101 56.3043C64.1002 56.5668 63.6767 56.7248 63.2262 56.746C62.7756 56.7672 62.3319 56.6499 61.9858 56.4181C61.6397 56.1864 61.4173 55.8576 61.364 55.4991L61.3516 55.3333V48.25H59.5807C59.147 48.25 58.7284 48.1226 58.4042 47.892C58.0801 47.6614 57.873 47.3437 57.8223 46.9991L57.8099 46.8333V38.3333C57.8099 35.2025 60.4661 31.25 63.1224 31.25ZM52.4974 31.25C52.9311 31.25 53.3498 31.3774 53.6739 31.608C53.998 31.8386 54.2051 32.1563 54.2558 32.5009L54.2682 32.6667V39.75C54.268 41.0064 53.7461 42.2272 52.7846 43.2205C51.823 44.2139 50.4762 44.9236 48.9557 45.2382V55.3333C48.9552 55.6944 48.7824 56.0417 48.4726 56.3043C48.1627 56.5668 47.7392 56.7248 47.2887 56.746C46.8381 56.7672 46.3944 56.6499 46.0483 56.4181C45.7022 56.1864 45.4798 55.8576 45.4265 55.4991L45.4141 55.3333V45.2382C43.9539 44.9362 42.6523 44.2694 41.6984 43.3349C40.7446 42.4003 40.1883 41.2467 40.1104 40.0418L40.1016 39.75V32.6667C40.1021 32.3056 40.2749 31.9583 40.5847 31.6957C40.8946 31.4332 41.318 31.2752 41.7686 31.254C42.2192 31.2328 42.6629 31.3501 43.009 31.5819C43.3551 31.8136 43.5775 32.1424 43.6308 32.5009L43.6432 32.6667V39.75C43.6432 40.2473 43.8069 40.7359 44.1177 41.1666C44.4286 41.5973 44.8757 41.955 45.4141 42.2037V32.6667C45.4146 32.3056 45.5874 31.9583 45.8972 31.6957C46.2071 31.4332 46.6305 31.2752 47.0811 31.254C47.5317 31.2328 47.9754 31.3501 48.3215 31.5819C48.6676 31.8136 48.89 32.1424 48.9433 32.5009L48.9557 32.6667L48.9575 42.2037C49.4517 41.9751 49.8695 41.6545 50.1753 41.2689C50.4812 40.8834 50.6661 40.4444 50.7142 39.9894L50.7266 39.75V32.6667C50.7266 32.2909 50.9131 31.9306 51.2452 31.6649C51.5773 31.3993 52.0277 31.25 52.4974 31.25Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_109_413",
    x: 0,
    y: 0,
    width: 107,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_109_413"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_109_413"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_109_413",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteIconFood);
export default __webpack_public_path__ + "static/media/WhiteIcon_Food.57d8190686500963394f7258daa5aa97.svg";
export { ForwardRef as ReactComponent };